

















































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { OfferService } from '@/data/services/offer.service';
import { dateEndofDay, download } from '@/data/utils/helper';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { UserStatsRiepilogo } from '@/data/models/userstats.model';
import { User } from '@/data/models/user.model';
import store, { State } from '@/store';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class FattorinoStats extends Vue {
    @Prop() fattorino?: User;
    
	@Inject('OfferService') offerService!: OfferService;

	rangeStats: Date[] = [];

	stats: UserStatsRiepilogo[] = [];

	state!: State;
	
	constructor() {
		super();
		this.state = store;
	}

	printStats() {
		const loading = this.$buefy.loading.open({});
		const start = Math.round(this.rangeStats[0].getTime() / 1000);
		const stop = Math.round(dateEndofDay(this.rangeStats[1]).getTime() / 1000);
		const req = this.fattorino ?
			this.offerService.printStatsFattorino(this.fattorino.id, start, stop) 
			: this.offerService.printStatsFattorini(this.state.headquarter!.id, start, stop);
		req.then(response => {
			const name = this.fattorino ? `stats_fattorini_${this.fattorino.id}.pdf` : 'stats_fattorini.pdf';
			download(response, name);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

}
